import firebase from "firebase/compat/app";
import "firebase/compat/auth";

// Initialize Firebase
const app = firebase.initializeApp({
    apiKey: "AIzaSyBC5Y1wYaQZEw698Y3ft6isasnx3Wg0buY",
    authDomain: "aysha-dental-care.firebaseapp.com",
    projectId: "aysha-dental-care",
    storageBucket: "aysha-dental-care.appspot.com",
    messagingSenderId: "1097522133688",
    appId: "1:1097522133688:web:d11bca0bf854b643d3124d"
});

export const auth = app.auth()
export default app